<template>
  <div id="countedStock">
    <vs-table noDataText="Tabloda Veri Yok" search :data="value">
      <template slot="header">
        <vs-button type="filled" color="danger" @click="controlData">Stok Kaydet</vs-button>
      </template>
      <template slot="thead">
        <vs-th>#</vs-th>
        <vs-th style="width:400px;" sort-key="productName">Ürün</vs-th>
        <vs-th>stok</vs-th>

        <vs-th>İşlem</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody ref="tbody">
          <vs-tr :id="'p'+i" :data="tr" :key="i" v-for="(tr, i) in data">
            <vs-td class="font-semibold truncate">{{ data.length-i }}</vs-td>
            <vs-td :title="tr.productName">{{ tr.productName }}</vs-td>
            <vs-td>{{ tr.quantity }}</vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                v-if="tr.barcodeList == null"
                icon="TrashIcon"
                svgClasses="w-6 h-6 hover:text-dark stroke-current"
                class="ml-2 hoverZoom"
                @click.stop="deleteItem(i)"
              />
            </vs-td>

            <template class="expand-user" slot="expand">
              <div class="con-expand-users w-full">
                <!-- barkodlu urunler -->
                <div v-if="tr.barcodeList">
                  <div
                    :id="'p'+ i + '_c'+index"
                    class="con-btns-user flex items-center justify-between"
                    style="background:#dededea8"
                    :key="index"
                    v-for="(item,index) in tr.barcodeList"
                  >
                    <div class="con-userx flex items-center justify-start">
                      <span>Barkod No: {{ item }}</span>
                    </div>
                    <div class="flex" style="background:#fff">
                      <vs-button
                        type="border"
                        style="float:right"
                        size="small"
                        
                        icon-pack="feather"
                        icon="icon-trash"
                        color="danger"
                        @click.stop="deletePiece(i,index)"
                      ></vs-button>
                    </div>
                  </div>
                </div>
                <!-- barkodsuz urunler -->
                <div v-if="!tr.barcodeList" :id="'p'+ i + '_c'">
                  <div class="con-btns-user flex items-center justify-between">
                    <div class="con-userx flex items-center justify-start"></div>
                    <div class="flex items-center mr-5">
                      <span>Adet Girin:</span>
                      <vs-input
                        size="small"
                        style="width: 50px;"
                        type="number"
                        v-model="barcodelessPiece"
                      ></vs-input>
                      <vs-button
                        class="ml-3"
                        type="border"
                        style="float:right"
                        size="small"
                        icon-pack="feather"
                        icon="icon-trash"
                        color="danger"
                        @click.stop="deletePiece(i)"
                      ></vs-button>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      barcodelessPiece: 0,
    };
  },
  methods: {
    deleteItem: function (index) {
      this.value.splice(index, 1);
      let el = "p" + index + "_c";
      let x = document.getElementById(el);
      x = x.parentElement;
      x.parentElement.setAttribute("style", "display:none !important");
    },
    deletePiece(i, barcode) {
      //barkodsuz urunu azaltarak sılme
      if (this.value[i].barcodeList == null) {
        if (
          this.barcodelessPiece &&
          this.barcodelessPiece <= this.value[i].quantity &&
          this.value[i].quantity > 0
        ) {
          this.value[i].quantity -= this.barcodelessPiece;
           this.barcodelessPiece = 0;
          let el = "p" + i + "_c";
          let x = document.getElementById(el);
          x = x.parentElement;
          x.parentElement.setAttribute("style", "display:none !important");
          if (this.value[i].quantity == 0) {
            this.value.splice(i, 1);
          }
        } 
        //sayı stoktan buyukse
        else {
          this.$vs.notify({
            title: "Hata!",
            text: "Adet stoktan büyük",
            color: "danger",
            icon: "warning",
          });
          return;
        }
      }
      //barkodlu urunu teklı sılme
      else {
        let a = this.value[i].barcodeList;
        a.splice(barcode, 1);
        this.value[i].barcodeList = a;
        this.value[i].quantity -= 1;
        let el = "p" + i + "_c" + barcode;
        document.getElementById(el).setAttribute("style", "display:none !important");
        
        if (this.value[i].quantity == 0) {
          this.value.splice(i, 1);
          let x = document.getElementById(el);
          x = x.parentElement;
          x = x.parentElement;
          x = x.parentElement;
          x = x.parentElement;
          x.parentElement.setAttribute("style", "display:none !important");
        }
      }
    },
    controlData() {
      this.$emit("save");
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
#countedStock{
.vs-table--tbody-table .tr-values td {
    padding: 5px !important;
  }
  .tr-expand td .content-tr-expand{
    padding: 2px !important;
  }
}

.hoverZoom :hover {
  -ms-transform: scale(1.2); /* IE 9 */
  -webkit-transform: scale(1.2); /* Safari 3-8 */
  transform: scale(1.2);
  cursor: pointer;
}
</style>
